import CreatePositionDto from './createPositionDto';

export enum DuplicateRosterPositionValues {
  DuplicateRoster = 'Duplicate Roster',
  SelectRoster = 'Select Roster',
  PasteIds = "Paste ID's",
  DontDuplicate = "Don't duplicate",
}

export interface EditPositionDto extends CreatePositionDto {
  Company?: {
    Id?: number;
    Name: string;
    Domain?: string;
    title?: string;
  };
  CandidatesCount?: number;
  DuplicationMethod?: DuplicateRosterPositionValues;
  DuplicateRosterData?: any;
  JobTypeIsntListed: boolean;
  IsPublic: boolean;
  ShowInterestedToEmployer: boolean;
}

export interface EditPositionFormDto extends Omit<
  EditPositionDto,
  'Languages'
> {
  Languages?: number[];
}

export interface IData extends EditPositionDto {
  ExperienceYears: number;
  Id?: number;
  Status: undefined;
  CandidatesPositionStatus: [];
}
